module.exports = __webpack_public_path__ + "img/bg1-info2.5cc9b79a.png";